import type { ImageType } from '@vizit/api';

/** A collection scored against a benchmark, as the API's benchmark collections listing returns it. */
interface BenchmarkCollectionRef {
  id: string;
  name: string;
  imageType: ImageType;
  productCategoryId: string | null;
  /** The collection's latest scoring against the benchmark, if any. */
  lastScoring?: { id: string; status: 'pending' | 'ready' | 'failed' } | null;
}

interface UseBenchmarkCollectionsProps {
  workspaceId?: string;
  benchmarkId?: string | null;
}

/**
 * The collections scored against a benchmark, which decide whether deleting needs an acknowledgement and whether
 * uploading shows the rescore opt-in. The API is adding `GET /benchmarks/{id}/collections` (paginated, total in
 * `Vizit-Total-Count`), but this does not fetch it yet: `collections` stays `undefined` (unknown), so delete shows
 * the plain confirm and upload shows no rescore notice. The rescore notice also stays off once the list is wired,
 * until adding images actually marks those collections' scorings pending.
 */
function useBenchmarkCollections(_props: UseBenchmarkCollectionsProps): { collections?: BenchmarkCollectionRef[] } {
  return { collections: undefined };
}

export { useBenchmarkCollections };
export type { BenchmarkCollectionRef };
